<template>
  <SectionContainerPage>
    <SectionLocationList
      xs12
      :locationList="locationList"
      :clientList="clientList"
      :sourceList="sourceList"
      :shouldShowSearch="true"
      :toolbarActions="[
        {
          text: 'Location',
          icon: 'add',
          iconColor: 'success',
          emitEvent: 'onAddNewLocationClicked',
        },
      ]"
      @onAddNewLocationClicked="showDialogFormLocationAdd = true"
      @onEditLocationClicked="
        (val) => [
          (locationToEdit = val.locationToEdit),
          (showDialogFormLocationEdit = true),
        ]
      "
      :isLoading="isLoading"
    />
    <DialogFormLocationAdd
      :showDialog="showDialogFormLocationAdd"
      :clientList="clientList"
      @onCancelClicked="showDialogFormLocationAdd = false"
      @onSubmitClicked="(val) => [onDialogFormLocationAddSubmit(val)]"
      :isLoading="isLoading"
    />
    <DialogFormLocationEdit
      :showDialog="showDialogFormLocationEdit"
      :clientList="clientList"
      :locationToEdit="locationToEdit"
      @onCancelClicked="showDialogFormLocationEdit = false"
      @onSubmitClicked="(val) => [onDialogFormLocationEditSubmit(val)]"
      :isLoading="isLoading"
    />
    <DialogFormConfirmation
      :showDialog="confirmationDialogShow"
      :title="confirmationDialogTitle"
      :message="confirmationDialogMessage"
      :submitButtonText="confirmationDialogSubmitButtonText"
      :submitButtonIcon="confirmationDialogSubmitButtonIcon"
      :submitButtonColor="confirmationDialogSubmitButtonColor"
      :cancelButtonText="confirmationDialogCancelButtonText"
      :showCancelButton="confirmationDialogShowCancelButton"
      @onSubmitClicked="onConfirmationDialogSubmitClicked"
      @onCancelClicked="onConfirmationDialogCancelClicked"
      :isLoading="isLoading"
    />
  </SectionContainerPage>
</template>

<script>
import mixinAssetApi from '../../../common/mixins/mixinAssetApi'
import mixinAssetHelper from '../../../common/mixins/mixinAssetHelper'
import mixinConfirmationDialog from '../../../common/mixins/mixinConfirmationDialog'

import SectionContainerPage from '../../../common/components/layouts/SectionContainerPage'
import SectionLocationList from './sections/SectionLocationList'
import DialogFormLocationAdd from '../dialogs/DialogFormLocationAdd'
import DialogFormLocationEdit from '../dialogs/DialogFormLocationEdit'
import DialogFormConfirmation from '../dialogs/DialogFormConfirmation'

export default {
  components: {
    SectionContainerPage,
    SectionLocationList,
    DialogFormLocationAdd,
    DialogFormLocationEdit,
    DialogFormConfirmation,
  },
  mixins: [mixinAssetApi, mixinAssetHelper, mixinConfirmationDialog],
  props: {},
  data: () => ({
    showDialogFormLocationAdd: false,
    showDialogFormLocationEdit: false,
    locationList: [],
    sourceList: [],
    clientList: [],
    locationToEdit: {},
    isLoadingCount: 0,
  }),
  activated() {
    this.fetchLists()
  },
  computed: {
    isLoading() {
      return this.isLoadingCount > 0
    },
  },
  watch: {
    isLoading() {
      this.$emit('isLoadingChange', this.isLoading)
    },
  },
  methods: {
    onDialogFormLocationAddSubmit(data) {
      this.isLoadingCount++
      this._insertLocation({
        name: data.name,
        clientId: data.clientId,
        successCb: () => {
          this.isLoadingCount--
          this.showDialogFormLocationAdd = false
          this.fetchLists()
          this.$emit('notify', { message: 'Location successfully created!' })
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    onDialogFormLocationEditSubmit(data) {
      this.isLoadingCount++
      this._updateLocation({
        id: data.id,
        name: data.name,
        clientId: data.clientId,
        isEnabled: data.isEnabled,
        successCb: () => {
          this.isLoadingCount--
          this.showDialogFormLocationEdit = false
          this.fetchLists()
          this.$emit('notify', { message: 'Location successfully updated!' })
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    fetchLists() {
      this.isLoadingCount++
      this._fetch({
        types: ['Location', 'Client', 'Source'],
        successCb: (data) => {
          this.isLoadingCount--
          this.locationList = data.locations
          this.sourceList = data.sources
          this.clientList = data.clients
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.locationList = []
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
  },
}
</script>
